import FullPage from '../../../components/full-page'
import loader from '../../../components/loader'
import SubscriptionUpsell from '../../../components/subscription-upsell'
import useBack from '../../../modules/navigation/hooks/use-back'
import withStore from '../../../utils/with-store'
import About from './components/about'
import Artist from './components/artist'
import Banner from './components/banner'
import Content from './components/content'
import Cover from './components/cover'
import Description from './components/description'
import Details from './components/details'
import Faq from './components/faq'
import Meta from './components/meta'
import Register from './components/register'
import Registered from './components/registered'
import RegistrationModal from './components/registrationModal'
import Reviews from './components/reviews'
import { RecordedHomeEl } from './elements'
import CourseHomeStore from './stores/course-home-store'

const Home = () => {
  useBack('/discover/courses/group')
  const { loading, loadFailed } = CourseHomeStore.useContainer()

  return loader(
    loading,
    loadFailed,
    <FullPage type='show-header'>
      <RecordedHomeEl>
        <Banner />
        <Meta />
        <Cover />
        <About />
        <Details />
        <Description />
        <Content />
        <Artist />
        <SubscriptionUpsell />
        <Reviews />
        <Register />
        <Registered />
        <Faq />
        <RegistrationModal />
      </RecordedHomeEl>
    </FullPage>,
  )
}

export default withStore([CourseHomeStore])(Home)
